import React from 'react';
import { HotFilterItem } from '@interfaces/api/responses/hot-filters.response';
import styles from './hot-filter-tabs.module.scss';

type HotFilterTabProps = {
  filterId: string;
  name: string;
  isActive: boolean;
  onClick: (filterId: string) => void;
  dataCy: string;
};

const HotFilterTab: React.FC<HotFilterTabProps> = ({ filterId, name, isActive, onClick, dataCy }) => {
  return (
    <button
      className={`${styles.hotFilter__tabs__button} ${isActive ? styles['hotFilter__tabs__button--active'] : ''}`}
      onClick={() => onClick(filterId)}
      data-cy={`${dataCy}${isActive ? '-active' : ''}`}
    >
      {name}
    </button>
  );
};

type HotFilterTabsProps = {
  data: HotFilterItem[];
  selectedTab: string;
  onTabChange: (tab: HotFilterItem) => void;
  dataCy: string;
};

const HotFilterTabs: React.FC<HotFilterTabsProps> = ({ data, selectedTab, onTabChange, dataCy }) => {
  const handleTabChange = (tab: HotFilterItem): void => {
    onTabChange?.(tab);
  };

  return (
    <div className={styles.hotFilter__tabs}>
      <div
        className={styles.hotFilter__tabs__navigation}
        data-cy={dataCy}
      >
        {data.map((tab) => (
          <HotFilterTab
            dataCy={`${dataCy}-${tab.id}`}
            key={tab.id}
            filterId={tab.id}
            name={tab.name}
            isActive={tab?.id === selectedTab}
            onClick={() => handleTabChange(tab)}
          />
        ))}
      </div>
    </div>
  );
};

export default HotFilterTabs;
